export function CardInput({
  value,
  placeholder,
  onChange,
  type,
  autoFocus,
  onClick,
  maxLength = 50,
  required,
}) {
  return (
    <input
      autoFocus={autoFocus}
      onClick={onClick}
      autoComplete="off"
      required={required}
      maxLength={maxLength}
      onChange={(e) => onChange(e.target.value)}
      type={type}
      className={
        "border-[1.5px] border-[#BABABA] rounded-xl h-12 px-4 py-2.5 text-base w-full"
      }
      value={value}
      placeholder={placeholder}
    />
  );
}
